import { baseApi } from './baseApi';

export const backupApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBackups: builder.query({
      query: () => '/backup',
      providesTags: ['Backup'],
    }),
    generateBackup: builder.mutation({
      query: () => ({
        url: '/backup/generate',
        method: 'POST',
      }),
      invalidatesTags: ['Backup'],
    }),
    deleteBackup: builder.mutation({
      query: (filename) => ({
        url: `/backup/${filename}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Backup'],
    }),
  }),
});

export const { useGetBackupsQuery, useGenerateBackupMutation, useDeleteBackupMutation } = backupApi;
